@use "../../styles/breakpoint.module.scss" as *;

.grid {
    composes: gridContainer from "../../styles/composable/layout.module.css";

    @media ($below-mobile) {
        --labui-grid-gap: var(--spacer-80);
    }
}
